module.exports = __webpack_public_path__ + "img/9.913d4869.png";